<template>
  <a-layout-footer class="non-auth-footer">
    <a-row justify="center" class="text-center">
      <a-col :lg="12" :md="18" :xs="24">
        <i18n-t keypath="recaptchaTerms" tag="div" class="mb-10">
          <template v-slot:privacyURL>
            <a
              href="https://policies.google.com/privacy"
              class="non-auth-footer__links"
              target="_blank"
            >
              {{ t("privacyPolicy") }}</a
            >
          </template>
          <template v-slot:termsURL>
            <a
              href="https://policies.google.com/terms"
              class="non-auth-footer__links"
              target="_blank"
            >
              {{ t("termsOfService") }}</a
            >
          </template>
        </i18n-t>
        <div class="non-auth-footer__desc mb-24">
          {{
            t("loginPage.footerText", {
              brandName,
              companyName,
              companyWebsite,
            })
          }}
        </div>
        <a-row class="ant-row ant-row-center mb-25" :gutter="16">
          <a-col>
            <a
              :href="config.privacyPolicyUrl"
              target="_blank"
              class="non-auth-footer__links-header"
            >
              {{ t("Privacy Policy") }}</a
            >
          </a-col>
          <a-col>
            <a
              :href="config.cookiePolicyUrl"
              target="_blank"
              class="non-auth-footer__links-header"
            >
              {{ t("Cookie Policy") }}</a
            >
          </a-col>
          <a-col>
            <a
              :href="config.termsWebsiteUseUrl"
              target="_blank"
              class="non-auth-footer__links-header"
            >
              {{ t("Terms of Website Use") }}</a
            >
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </a-layout-footer>
</template>

<style scoped lang="scss">
.non-auth-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;

  &.ant-layout-footer {
    padding: $padding-lg;
    background: inherit;
    font-size: $non-auth-footer-font-size;
    color: $non-auth-footer-desc-color;
  }

  a.non-auth-footer__links {
    color: $non-auth-footer-link-color;
  }

  a.non-auth-footer__links-header {
    color: $non-auth-footer-link-color;
  }

  &__desc {
    text-align: center;
  }

  &__captcha-terms {
    color: $non-auth-footer-desc-color;
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { config } from "@/shared/utils/config";
import { isPrivateSite } from "@/shared/utils/config";

export default defineComponent({
  setup() {
    const t = useI18n().t;

    return {
      t,
      config,
      brandName: config.merchantBrand,
      companyName: config.companyName,
      companyWebsite: config.companyWebsite,
      isPrivateSite,
    };
  },
});
</script>
